"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var Query_1 = require("../Query");
var number_1 = require("../../utils/number");
var NumberTransform = /** @class */ (function (_super) {
    __extends(NumberTransform, _super);
    function NumberTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        if (queryResponse && number_1.isNumber(queryResponse)) {
            var numberOptions = this.options.numberOptions;
            if (numberOptions && numberOptions.operator) {
                var value = numberOptions.value;
                if (numberOptions.valueQuery) {
                    var valueQuery = new Query_1.Query(numberOptions.valueQuery);
                    value = valueQuery.execute(executionOptions);
                }
                try {
                    var response = void 0;
                    switch (numberOptions.operator) {
                        case 'multiply':
                            response = queryResponse * value;
                            break;
                        case 'divide':
                            response = queryResponse / value;
                            break;
                        case 'add':
                            response = queryResponse + value;
                            break;
                        case 'subtract':
                            response = queryResponse - value;
                            break;
                        case 'modulus':
                            response = queryResponse % value;
                            break;
                        default:
                            response = queryResponse;
                    }
                    if (numberOptions.roundingOptions) {
                        var decimalMultiplier = 1;
                        if (numberOptions.roundingOptions.decimalPlaces) {
                            decimalMultiplier = Math.pow(10, numberOptions.roundingOptions.decimalPlaces);
                        }
                        switch (numberOptions.roundingOptions.type) {
                            case 'standard':
                                return (Math.round(response * decimalMultiplier)) / decimalMultiplier;
                            case 'ceiling':
                                return (Math.ceil(response * decimalMultiplier)) / decimalMultiplier;
                            case 'floor':
                                return (Math.floor(response * decimalMultiplier)) / decimalMultiplier;
                            default:
                                return response;
                        }
                    }
                    return response;
                }
                catch (ex) {
                    console.warn("Error while performing NumberTransform, queryResponse: " + queryResponse + ", operator: " + numberOptions.operator + ", value: " + value + ", error: ", ex);
                }
            }
        }
        return queryResponse;
    };
    return NumberTransform;
}(BaseTransform_1.BaseTransform));
exports.NumberTransform = NumberTransform;
//# sourceMappingURL=NumberTransform.js.map